import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { HeroSection } from '@/components/home/HeroSection';
import { AboutSection } from '@/components/home/AboutSection';
import { GalleryCarousel } from '@/components/home/GalleryCarousel';
import { LocationSection } from '@/components/home/LocationSection';
import { TestimonialsSection } from '@/components/home/TestimonialsSection';

const HomePage = () => {
  return (
    <Layout>
      <HeroSection />
      <AboutSection />
      <GalleryCarousel />
      <TestimonialsSection />
      <LocationSection />
    </Layout>
  );
};

export default HomePage;
